"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagTheme = exports.TagState = exports.TagSize = void 0;
var TagSize = exports.TagSize = /*#__PURE__*/function (TagSize) {
  TagSize["Small"] = "sm";
  TagSize["Medium"] = "md";
  TagSize["Large"] = "lg";
  return TagSize;
}({}); // We plan to add more themes in the future
var TagTheme = exports.TagTheme = /*#__PURE__*/function (TagTheme) {
  TagTheme["Default"] = "default";
  TagTheme["Accent"] = "accent";
  return TagTheme;
}({});
var TagState = exports.TagState = /*#__PURE__*/function (TagState) {
  TagState["Default"] = "default";
  TagState["Highlighted"] = "highlighted";
  return TagState;
}({});
//# sourceMappingURL=HBTag.types.js.map